module.exports = __webpack_public_path__ + "img/instructions_01.03fe5d29.svg";